module.exports = __webpack_public_path__ + "static/media/fire-is-correct.9db5f231.mp3";